<div
    #triggerRef
    (mouseenter)="usesTouchLayout ? null : OpenPanel(true)"
    (mouseleave)="usesTouchLayout ? null : SchedulePanelClose()"
    (click)="TogglePanel()"
    (focusout)="HandleFocusOut($event, false)"
    (keydown.escape)="ClosePanelFromKeyboard(); $event.stopPropagation()">
    <lib-sidebar-item
        [icon]="Icon.Common.MoreHoriz"
        navigationTitle='More'
        [isAction]="true"
        [expanded]="panelOpen"
        [controls]="panelOpen ? 'sidebar-overflow-panel' : undefined"
        [linkActive]="activeItemState()"
        [disableTooltip]="true"></lib-sidebar-item>
</div>

@if (panelOpen) {
    @if (usesTouchLayout) {
        <div class="sb-sidebar-overflow-backdrop" (click)="ClosePanel()"></div>
        <div
            #bottomSheetRef
            id="sidebar-overflow-panel"
            class="sb-sidebar-overflow-bottom-sheet"
            (focusout)="HandleFocusOut($event, true)"
            (keydown.escape)="ClosePanelFromKeyboard(); $event.stopPropagation()">
            <ng-container *ngTemplateOutlet="overflowItemList"></ng-container>
        </div>
    } @else {
        <div
            #panelRef
            id="sidebar-overflow-panel"
            class="sb-sidebar-overflow-panel"
            [ngStyle]="panelStyle"
            (focusout)="HandleFocusOut($event, true)"
            (mouseenter)="KeepPanelOpen()"
            (mouseleave)="SchedulePanelClose()"
            (keydown.escape)="ClosePanelFromKeyboard(); $event.stopPropagation()">
            <ng-container *ngTemplateOutlet="overflowItemList"></ng-container>
        </div>
    }
}

<ng-template #overflowItemList>
    @for (item of items(); track item.routerLink; let i = $index) {
        @if (i > 0 && items()[i - 1].visibility === NavigationItemState.Show && item.visibility !== NavigationItemState.Show) {
            <div class="sb-sidebar-overflow-divider"></div>
        }
        <lib-sidebar-item
            [icon]="item.icon"
            [navigationTitle]="item.navigationTitle"
            [routerLink]="item.routerLink"
            [fragment]="item.fragment"
            [queryParams]="item.queryParams"
            [badgeText]="item.badgeText"
            [linkActive]="item.linkActive"
            [textAlwaysVisible]="true"
            (click)="SelectOverflowItem()"></lib-sidebar-item>
    }
</ng-template>

